/* Decor Walay — deal-of-day.js
   Live countdown to a target date/time set via the section's data-countdown attribute.
   A date without a timezone is read as Pakistan time (UTC+5), so the timer ends at the same
   moment as the Shopify discount for every visitor. When it ends, the section gets an
   "is-ended" class and everything marked [data-offer-only] is hidden. */

document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.slice.call(document.querySelectorAll('[data-countdown]')).forEach(function (el) {
    var raw = String(el.getAttribute('data-countdown') || '').trim();
    if (raw && !/(Z|[+-]\d\d:?\d\d)$/.test(raw)) raw += '+05:00';
    var target = new Date(raw).getTime();
    if (isNaN(target)) return;

    var section = el.closest('.deal-of-day');
    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minutesEl = el.querySelector('[data-countdown-minutes]');
    var secondsEl = el.querySelector('[data-countdown-seconds]');
    var timer = null;

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target - Date.now();

      if (diff <= 0) {
        if (timer) clearInterval(timer);
        if (section) section.classList.add('is-ended');
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    if (!section || !section.classList.contains('is-ended')) timer = setInterval(tick, 1000);
  });
});
